import { connect } from 'react-redux'
import { listSubscriptionPlans } from '../../state/actions/subscriptions'
import { IStoreState } from '../../types'
import SubscriptionPane from '../../components/subscriptions/SubscriptionPane'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  const currentOrg = state.organizations.items[ownProps.orgId]
  return {
    currentPlanId:
      currentOrg && currentOrg.subscription ? currentOrg.subscription.subscriptionPlanId : ownProps.currentPlanId,
    stripeSourceId: ownProps.stripeSourceId,
    onPlanSelect: ownProps.onPlanSelect,
    organization: currentOrg || ownProps.organization,
    plans: state.subscriptionPlans.items,
    fetchingPlans: state.subscriptionPlans.isFetching,
    processing: state.organizations.metadata.fetching
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    listSubscriptionPlans: () => dispatch(listSubscriptionPlans())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionPane)



// WEBPACK FOOTER //
// ./src/containers/subscriptions/SubscriptionPane.ts